import type { ReactElement, ReactNode } from 'react';
import { Children, cloneElement, isValidElement } from 'react';

export function iconWithProps(icon: ReactNode, label?: string) {
  return Children.map(icon, (child) => {
    if (isValidElement(child)) {
      const altText = child.props.altText || label;
      const color = child.props.color || 'inherit';
      return cloneElement(
        child as ReactElement<{ altText: string; color: string }, string>,
        {
          altText,
          color,
        }
      );
    }
    return child;
  });
}
